import TableWrapper from "../../../../../Components/Common/Tables/Tanstack/components/TableWrapper";
import CommonHeader from "../../../../../Components/Common/CommonHeader/CommonHeader";
import { useDispatch, useSelector } from "react-redux";
import useSelectedPspMappingColumns from "../Hooks/useSelectedPspMappingColumns";
import useSelectedAgMappingColumns from "../Hooks/useSelectedAgMappingColumns";
import { getUserOrgListing } from "../UserService";
import {
  setAgMappingData,
  setUserSorting,
} from "../../../../../slices/team/users/usersSlice";
import { useEffect } from "react";
import { getOrganizationId, getOrgId } from "../../../../../Utils/CommonUtils";
import UserFilter from "../UserFilter";
import SelectDropdownAgMapping from "./SelectDropdownAgMapping";
import { getFilteredDataWithTabs } from "../../../../../Utils/CommonService";
import AgFilter from "./AgFilter";

const AgMaping = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.users.selectedUser.detailsData);
  const triggerRender = useSelector((state) => state.common.triggerRender);
  const apiTabData = useSelector((state) => state.common.pagination.tabs);
  const filterForm = useSelector((state) => state.users.agMappingFilter.form);
  const filterApi = useSelector(
    (state) => state.users.agMappingFilter.filterApi
  );
  const sortColumn = useSelector((state) => state.users.agSorting.column);
  const sortOrder = useSelector((state) => state.users.agSorting.order);
  // const organizationId = getOrgId();
  const enterpriseid = localStorage.getItem("enterpriseid");

  const agMappingData = useSelector(
    (state) => state.users.selectedUser.agMappingData
  );
  const { agMappingColumns, selectedRows, selectAll } =
    useSelectedAgMappingColumns(agMappingData);
  const ownerId = getOrganizationId();
  const totalRows = useSelector((state) => state.common.pagination.totalCount);
  const userid = localStorage.getItem("userId");

  return (
    <div>
      <CommonHeader
        filterComponent={<AgFilter />}
        selectComponent={
          <SelectDropdownAgMapping selectedRows={selectedRows} />
        }
        dash={true}
      />
      <div className="drill-table-mapping">
        <TableWrapper
          columns={agMappingColumns}
          data={agMappingData}
          apiTabData={apiTabData}
          paginatedApi
          filterApi={filterApi}
          filterApiEntity={"AGRP"}
          filterApiListEntity={"UAGM"}
          filterApiFunction={setAgMappingData}
          filterApiService={!selectAll ? getFilteredDataWithTabs : () => {}}
          filterForm={filterForm}
          totalRows={totalRows}
          status={"ALL"}
          statusColumn={"status"}
          serverSort
          serverSortColumn={sortColumn}
          serverSortOrder={sortOrder}
          serverSortState={setUserSorting}
          enterpriseId={enterpriseid}
          userId={data.user_id}
          ownerId={ownerId}
          hideTabsWrapper={true}
        />
      </div>
    </div>
  );
};

export default AgMaping;
